// extracted by mini-css-extract-plugin
export default {"multiRowTable":"_11-OtherInfo_multiRowTable__SXGLo","icon":"_11-OtherInfo_icon__mm9SX"};